export interface OpenIdSettings {
    type: OpenIdProvider,
    clientId: string,
    authority: string,
    redirectUri: string,
    issuer?: string,
    authorization_endpoint?: string,
    token_endpoint?: string,
    jwks_uri?: string,
    userinfo_endpoint?: string,
}

export interface OktaConfig { 
    domain: string,
    clientId: string,
    postLogoutRedirectUri: string,
}

export enum OpenIdProvider
{
    None,
    Microsoft,
    Okta,
}